export default __webpack_public_path__ + "static/media/Image1.b5b587fe.png";